import React from 'react'
import { useNavigate } from 'react-router-dom'
import { mainRouteInitial } from '../../Data/Constant'
import { useTranslation } from 'react-i18next';

const RegistrationMessage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const handleNavigateToVenderDashboard = () => {
    navigate(`/${mainRouteInitial}/VendorDashboard`)
  }
  return (
    <div className="flex flex-col items-center gap-6 text-center">
      {/* Hero Icon */}
      <div className="flex items-center justify-center rounded-full bg-green-50 dark:bg-green-900/20 p-6 mb-2">
        <span className="material-symbols-outlined text-green-500 text-6xl" style={{ fontSize: 64, fontVariationSettings: '"FILL" 1' }}>check_circle</span>
      </div>
      <div className="flex flex-col items-center gap-4">
        <h1 className="text-3xl font-extrabold leading-tight tracking-[-0.015em] text-slate-900 dark:text-white">{t('registrationSuccessful')}</h1>
        <div className="space-y-4 max-w-md">
          <p className="text-slate-600 dark:text-slate-300 text-base font-normal leading-relaxed">
            {t('thankYouForRegistering')}
          </p>
          {/* <div className="bg-slate-50 dark:bg-slate-900/50 rounded-lg p-4 border border-slate-100 dark:border-slate-700">
            <p className="text-xs font-bold text-slate-500 dark:text-slate-400 font-medium uppercase tracking-wider mb-1">{t('vendorId')}</p>
            <p className="text-lg font-mono font-bold text-slate-800 dark:text-slate-200 select-all">#VEND-2023-849</p>
          </div>
          <p className="text-slate-600 dark:text-slate-300 text-xs font-bold font-normal leading-relaxed">
            {t('confirmationEmailSent')}
          </p> */}
        </div>
      </div>
      <div className="flex flex-col w-full gap-3 mt-4">
        <button onClick={handleNavigateToVenderDashboard} className="flex w-full cursor-pointer items-center justify-center overflow-hidden rounded-lg h-12 px-6 bg-primary hover:bg-primary/90 text-white text-base font-bold leading-normal tracking-[0.015em] transition-all shadow-md hover:shadow-lg">
          <span className="truncate">{t('proceedToDashboard')}</span>
        </button>
      </div>
    </div>
  )
}

export default RegistrationMessage